import React from "react";
import JourneyMilestoneFormPage from "../components/journey-milestones/JourneyMilestoneFormPage";

const JourneyMilestoneCreate = () => <JourneyMilestoneFormPage mode="create" />;

export default JourneyMilestoneCreate;
